"use client";

import React from 'react';
import Image from 'next/image';
import { useLocale } from "@/context/LocaleContext";

export default function DigitalEnvelopeFeature() {
  const { t } = useLocale(); 

  return (
    <div className="w-full">
      <section className="w-full bg-gray-50 py-16">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20">
            <div className="w-full md:w-[48%] flex justify-center">
              <div className="relative w-full max-w-[450px] aspect-[4/5]">
                <Image 
                  src="/images/cta/amplop-digital.webp" 
                  alt="Cara kerja Amplop Digital" 
                  fill 
                  className="object-contain drop-shadow-2xl md:scale-105" 
                />
              </div>
            </div>

            <div className="w-full md:w-[52%] lg:pl-6">
              <h2 className="text-3xl md:text-4xl lg:text-[2.4rem] font-extrabold text-gray-900 mb-8 leading-tight">
                {t("DigitalEnvelope.how_it_works") || "Bagaimana Cara Kerjanya?"}
              </h2>
              
              <div className="space-y-6 lg:space-y-8">
                <div className="flex items-start gap-4 lg:gap-5">
                  <span className="text-xl md:text-2xl font-black text-gray-900 mt-0.5">1.</span>
                  <div>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1.5">
                      {t("DigitalEnvelope.step1_title") || "Tamu Mengirim Amplop Digital"}
                    </h3>
                    <p className="text-gray-700 leading-relaxed text-[15px] md:text-[16px] lg:text-[17px]">
                      {t("DigitalEnvelope.step1_desc") || "Tamu dapat mengirimkan hadiah uang melalui undangan digital menggunakan metode pembayaran yang tersedia."}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 lg:gap-5">
                  <span className="text-xl md:text-2xl font-black text-gray-900 mt-0.5">2.</span>
                  <div>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1.5">
                      {t("DigitalEnvelope.step2_title") || "Notifikasi Realtime"}
                    </h3>
                    <p className="text-gray-700 leading-relaxed text-[15px] md:text-[16px] lg:text-[17px]">
                      {t("DigitalEnvelope.step2_desc") || "Setiap amplop yang masuk akan langsung memberi notifikasi kepada pemilik acara."}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 lg:gap-5">
                  <span className="text-xl md:text-2xl font-black text-gray-900 mt-0.5">3.</span>
                  <div>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1.5">
                      {t("DigitalEnvelope.step3_title") || "Dana Tercatat & Bisa Ditarik"}
                    </h3>
                    <p className="text-gray-700 leading-relaxed text-[15px] md:text-[16px] lg:text-[17px]">
                      {t("DigitalEnvelope.step3_desc") || "Dana yang diterima tercatat secara otomatis dan dapat ditarik (withdraw) kapan saja."}
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="w-full bg-white py-16 md:py-24 border-y border-gray-100">
  <div className="max-w-[1200px] mx-auto px-4 md:px-8">
    
    <h2 className="text-3xl md:text-4xl lg:text-[2.8rem] font-bold text-gray-900 mb-12 md:mb-16 text-center tracking-tight">
      {t("DigitalEnvelope.main_benefits") || "Keuntungan Utama"}
    </h2>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
      
      {/* CARD 1 */}
      <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 md:p-10 shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group overflow-hidden">
        <div className="absolute top-5 right-6 md:top-6 md:right-8 text-[4rem] md:text-[5rem] font-bold text-gray-300 leading-none z-0 select-none group-hover:text-gray-400 transition-colors duration-300">
          1
        </div>
        <div className="w-16 h-16 mt-6 md:mt-8 mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300">
          <Image src="/images/icons/notif-ad.svg" alt="Icon notifikasi" fill className="object-contain" />
        </div>
        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 relative z-10">
          {t("DigitalEnvelope.card1_title") || "Notifikasi Realtime"}
        </h3>
        <p className="text-gray-700 text-[15px] md:text-[16px] leading-relaxed relative z-10 pr-4">
          {t("DigitalEnvelope.card1_desc") || "Pemilik acara langsung mengetahui setiap amplop yang masuk tanpa perlu mengecek manual."}
        </p>
      </div>

      {/* CARD 2 */}
      <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 md:p-10 shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group overflow-hidden">
        <div className="absolute top-5 right-6 md:top-6 md:right-8 text-[4rem] md:text-[5rem] font-bold text-gray-300 leading-none z-0 select-none group-hover:text-gray-400 transition-colors duration-300">
          2
        </div>
        <div className="w-16 h-16 mt-6 md:mt-8 mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300">
          <Image src="/images/icons/history-ad.svg" alt="Icon riwayat" fill className="object-contain" />
        </div>
        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 relative z-10 pr-8">
          {t("DigitalEnvelope.card2_title") || "Riwayat Transaksi yang Jelas"}
        </h3>
        <p className="text-gray-700 text-[15px] md:text-[16px] leading-relaxed relative z-10 mb-3">
          {t("DigitalEnvelope.card2_desc_1") || "Semua transaksi tercatat rapi, lengkap dengan:"}
        </p>
        <ul className="list-disc pl-5 space-y-1 text-gray-700 text-[15px] md:text-[16px] relative z-10 mb-3">
          <li>{t("DigitalEnvelope.card2_li_1") || "Nama pengirim"}</li>
          <li>{t("DigitalEnvelope.card2_li_2") || "Waktu transaksi"}</li>
          <li>{t("DigitalEnvelope.card2_li_3") || "Nominal yang diterima"}</li>
        </ul>
        <p className="text-gray-700 text-[15px] md:text-[16px] leading-relaxed relative z-10 pr-2">
          {t("DigitalEnvelope.card2_desc_2") || "Memudahkan pemilik acara melakukan pencatatan dan rekap."}
        </p>
      </div>

      {/* CARD 3 */}
      <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 md:p-10 shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group overflow-hidden">
        <div className="absolute top-5 right-6 md:top-6 md:right-8 text-[4rem] md:text-[5rem] font-bold text-gray-300 leading-none z-0 select-none group-hover:text-gray-400 transition-colors duration-300">
          3
        </div>
        <div className="w-16 h-16 mt-6 md:mt-8 mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300">
          <Image src="/images/icons/wd-ad.svg" alt="Icon withdraw" fill className="object-contain" />
        </div>
        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 relative z-10 pr-4">
          {t("DigitalEnvelope.card3_title") || "Penarikan Dana yang Mudah (Withdraw)"}
        </h3>
        <p className="text-gray-700 text-[15px] md:text-[16px] leading-relaxed relative z-10 pr-2">
          {t("DigitalEnvelope.card3_desc") || "Dana yang terkumpul dapat ditarik dengan proses yang mudah dan transparan sesuai ketentuan."}
        </p>
      </div>

      {/* CARD 4 */}
      <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 md:p-10 shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group overflow-hidden">
        <div className="absolute top-5 right-6 md:top-6 md:right-8 text-[4rem] md:text-[5rem] font-bold text-gray-300 leading-none z-0 select-none group-hover:text-gray-400 transition-colors duration-300">
          4
        </div>
        <div className="w-16 h-16 mt-6 md:mt-8 mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300">
          <Image src="/images/icons/secure-ad.svg" alt="Icon aman transparan" fill className="object-contain" />
        </div>
        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 relative z-10">
          {t("DigitalEnvelope.card4_title") || "Aman & Transparan"}
        </h3>
        <p className="text-gray-700 text-[15px] md:text-[16px] leading-relaxed relative z-10 mb-3">
          {t("DigitalEnvelope.card4_desc") || "Kami menerapkan sistem yang dirancang untuk menjaga keamanan dan transparansi transaksi:"}
        </p>
        <ul className="list-disc pl-5 space-y-1 text-gray-700 text-[15px] md:text-[16px] relative z-10">
          <li>{t("DigitalEnvelope.card4_li_1") || "Setiap transaksi tercatat dalam sistem"}</li>
          <li>{t("DigitalEnvelope.card4_li_2") || "Data dapat diakses kapan saja oleh pemilik acara"}</li>
          <li>{t("DigitalEnvelope.card4_li_3") || "Proses withdraw dilakukan secara terkontrol"}</li>
        </ul>
      </div>

      {/* CARD 5 */}
      <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 md:p-10 shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group overflow-hidden">
        <div className="absolute top-5 right-6 md:top-6 md:right-8 text-[4rem] md:text-[5rem] font-bold text-gray-300 leading-none z-0 select-none group-hover:text-gray-400 transition-colors duration-300">
          5
        </div>
        <div className="w-16 h-16 mt-6 md:mt-8 mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300">
          <Image src="/images/icons/pas-ad.svg" alt="Icon cocok digunakan" fill className="object-contain" />
        </div>
        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 relative z-10">
          {t("DigitalEnvelope.card5_title") || "Cocok Digunakan Untuk"}
        </h3>
        <ul className="list-disc pl-5 space-y-2 text-gray-700 text-[15px] md:text-[16px] relative z-10">
          <li>{t("DigitalEnvelope.card5_li_1") || "Pernikahan & acara keluarga"}</li>
          <li>{t("DigitalEnvelope.card5_li_2") || "Acara adat"}</li>
          <li>{t("DigitalEnvelope.card5_li_3") || "Event profesional"}</li>
          <li>{t("DigitalEnvelope.card5_li_4") || "Acara dengan tamu dari berbagai lokasi"}</li>
        </ul>
      </div>

      {/* CARD 6 */}
      <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 md:p-10 shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group overflow-hidden">
        <div className="absolute top-5 right-6 md:top-6 md:right-8 text-[4rem] md:text-[5rem] font-bold text-gray-300 leading-none z-0 select-none group-hover:text-gray-400 transition-colors duration-300">
          6
        </div>
        <div className="w-16 h-16 mt-6 md:mt-8 mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300">
          <Image src="/images/icons/setting-auto-share.svg" alt="Icon terintegrasi" fill className="object-contain" />
        </div>
        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 relative z-10 pr-6">
          {t("DigitalEnvelope.card6_title") || "Terintegrasi dengan Sistem Undangan"}
        </h3>
        <p className="text-gray-700 text-[15px] md:text-[16px] leading-relaxed relative z-10 mb-3">
          {t("DigitalEnvelope.card6_desc") || "Amplop Digital Otomatis terhubung langsung dengan:"}
        </p>
        <ul className="list-disc pl-5 space-y-1 text-gray-700 text-[15px] md:text-[16px] relative z-10 mb-4">
          <li className="font-semibold">{t("DigitalEnvelope.card6_li_1") || "Custom RSVP"}</li>
          <li className="font-semibold">{t("DigitalEnvelope.card6_li_2") || "Sebar otomatis via WhatsApp"}</li>
          <li className="font-semibold">{t("DigitalEnvelope.card6_li_3") || "Laporan transaksi & notifikasi"}</li>
        </ul>
        <p className="text-gray-800 text-[15px] md:text-[16px] leading-relaxed relative z-10 font-medium">
          {t("DigitalEnvelope.card6_footer") || "Semua dalam satu dashboard yang mudah digunakan."}
        </p>
      </div>

    </div>
  </div>
</section>

    </div>
  );
}